<template>
  <div>
    <Loader :loader-primario="loader" />

    <Alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <v-container>
      <v-row>
        <v-col>
          <h2 class="titulo-avaliacao titulo-secao">
            Feedback
            <span>Acompanhe seu Feedback</span>
          </h2>
        </v-col>
      </v-row>

      <template v-if="hasCiclo">
        <v-row v-if="ciclo.feedbackColaborador === null">
          <v-col>
            <p class="mb-0">
              <b>Você recebeu o feedback do seu gestor?</b> <span class="red--text">*</span>
            </p>
            <span v-if="showError" class="red--text text-caption mb-n4">
              Por favor marcar se recebeu o feedback
            </span>

            <div class="checkbox-div">
              <v-checkbox
                v-model="feedback"
                @change="hideError"
                :true-value="true"
                :false-value="null"
                label="Sim"
              ></v-checkbox>
              <v-checkbox
                v-model="feedback"
                @change="hideError"
                :true-value="false"
                :false-value="null"
                label="Não"
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="header">
            <h2 class="ms-4">
              <v-icon size="20" class="me-2">fas fa-circle-info</v-icon>
              Informações do Feedback
            </h2>
          </v-col>
          <v-col cols="12">
            <p><b>Gestor Avaliador:</b> {{ dadosFeedback.nomeGestor }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h2 class="categoria titulo-secao">Feedback</h2>
            <p><b>Cometários do gestor:</b> {{ dadosFeedback.comentarioFeedback }}</p>
          </v-col>
          <v-col cols="12">
            <h2 class="categoria titulo-secao">Anexos</h2>
            <p><b>Estes documentos foram incluídos pelo avaliador como parte do feedback:</b></p>
            <template v-for="anexo in anexos">
              <FileViewer :file="anexo" class="mb-2" />
            </template>
            <template v-if="!anexos.length">
              <p>
                <v-icon size="20" class="me-2">fas fa-triangle-exclamation</v-icon>
                <b>Aviso! Nenhum arquivo foi incluído pelo avaliador para este feedback</b>
              </p>
            </template>
          </v-col>
          <v-col
            v-if="ciclo.feedbackColaborador === null"
            cols="12"
            md="6"
            lg="3"
            offset-md="6"
            offset-lg="9"
          >
            <v-btn @click="validarEEnviar" class="botao-principal w-100">Confirmar Feedback</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <Aviso
          message="Ainda não há um feedback registrado para você. Assim que estiver disponível, você poderá visualizá-lo aqui."
        />
      </template>
    </v-container>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Alerta from '@/components/Alerta.vue';
import FileViewer from '@/components/FileViewer.vue';
import Aviso from '@/components/Aviso.vue';
import modalMixin from '@/mixins/modalMixin';
import api from '@/services/Api.js';
import JS from './methods.js';

export default {
  name: 'ViewFeedback',
  components: { Loader, Alerta, FileViewer, Aviso, api },
  mixins: [modalMixin],
  props: {
    cod_avaliacao: { type: Number, default: null },
  },
  data() {
    return {
      loader: false,
      feedback: null,
      showError: false,
      dadosFeedback: {},
      anexos: [],
      ciclo: {},
      hasCiclo: false,
    };
  },
  methods: {
    ...JS,
    hideError() {
      this.showError = false;
    },
    onInput(value) {
      this.feedback = value;
      this.hideError();
      this.$emit('update:modelValue', value);
    },
    async listarCiclos() {
      this.loader = true;
      try {
        const { status, data } = await api.get(`avaliacaoDesempenho/ciclosColaborador`, {
          headers: { Authorization: localStorage.token },
          withCredentials: true,
          params: { page: 1, perPage: 10 },
        });
        if (status !== 200) return;

        this.ciclo = data.result[0];
        this.hasCiclo = data.result[0] && data.result[0].status === 'Encerrado';
        this.fetchFeedback(this.ciclo.codAvaliacao);
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
    async fetchFeedback(codAvaliacao) {
      if (!codAvaliacao) return;

      this.loader = true;
      try {
        const { data } = await api.get(`avaliacaoDesempenho/feedbackColaborador/${codAvaliacao}`);
        this.dadosFeedback = data;
        this.anexos = data.anexos.map(file => JS.createFileFromBase64(file.nomeAnexo, file.anexo));
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
    validarEEnviar() {
      if (this.feedback === null) {
        this.showError = true;
        return;
      }
      this.putFeedback();
    },
    async putFeedback() {
      this.loader = true;
      this.ciclo.feedbackColaborador = this.feedback;
      try {
        await api.put(`avaliacaoDesempenho/feedbackColaborador`, this.ciclo);
        this.mensagemSucesso('As informações foram enviada e salvas com sucesso no sistema!');
        window.location.reload();
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
  },
  async mounted() {
    this.listarCiclos();
  },
};
</script>

<style scoped>
.categoria {
  position: relative;
  padding-left: 1rem;
}
.categoria::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0.25rem;
  height: 90%;
  background-color: #278b97;
  border-radius: 0.25rem 0 0 0.25rem;
}
.checkbox-div {
  display: flex;
  gap: 1.25rem;
  .v-input--selection-controls {
    margin-top: 0;
  }
}
</style>
